import { Outlet } from 'react-router-dom'
import HeaderLogo from '../components/HeaderLogo'
/**
 * `PaymentLayout` serves as a layout wrapper for payment-related pages.
 * It includes a `HeaderLogo` component at the top and renders nested routes using `Outlet`.
 *
 * @returns {JSX.Element} The payment layout component.
 */
export default function PaymentLayout() {
    return (
        <div className='flex flex-col h-screen'>
            {/* Displays the header logo */}
            <HeaderLogo />
            {/* Renders the nested routes */}
            <Outlet />
        </div>
    )
}
